// Apply theme before bootstrap so all pages (including public) get the right theme instantly
(() => {
  const stored = localStorage.getItem('tbd_prod_theme');
  const dark = stored === 'abs-dark';
  const body = document.body;
  body.setAttribute('data-theme', dark ? 'abs-dark' : 'abs-light');
  body.classList.remove(dark ? 'abs-light-theme' : 'abs-dark-theme');
  body.classList.add(dark ? 'abs-dark-theme' : 'abs-light-theme');
})();

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
